import { baseUniDriverFactory } from '../test-utils/utils/unidriver';
import { dataHooks } from './constants';

const byDataHook = dataHook => `[data-hook="${dataHook}"]`;

export const sortableGridBaseUniDriverFactory = base => {
  return {
    ...baseUniDriverFactory(base),
    startFixedElementExists: async () =>
      base.$(byDataHook(dataHooks.START_FIXED_ELEMENT)).exists(),
    endFixedElementExists: async () =>
      base.$(byDataHook(dataHooks.END_FIXED_ELEMENT)).exists(),
  };
};
